import {
  PaymentRedriveApiFactory,
  RedriveApiFactory,
} from "../../lusca-search-api/LuscaSearchApiFactory";
import { Stage } from "../../lusca-search-api/generated-src";
import { devUserQuery } from "../../helpers/devUser";

interface RedriveExecutionSummary {
  executionId?: string;
  stage?: string;
  user?: string;
  count?: number;
  executor?: string;
  status?: string;
  timestamp?: number;
}

export interface RedriveExecutionFile {
  downloadUrl?: string;
  executor?: string;
  status?: string;
  timestamp?: number;
  count?: number;
}

/** A CSV-driven redrive state machine and the API that lists its executions. */
export interface RedriveKind {
  name: string;
  stateMachineName: string;
  listExecutions: (stage: Stage) => Promise<RedriveExecutionSummary[]>;
  getExecutionFile: (
    executionId: string,
    stage: Stage
  ) => Promise<RedriveExecutionFile>;
  itemHref?: (itemId: string, stage: Stage, user?: string) => string;
}

export const ORDER_REDRIVE: RedriveKind = {
  name: "Order",
  stateMachineName: "orderredrivestatemachine",
  listExecutions: async (stage) => {
    const { data } = await RedriveApiFactory().getRedriveInfo(stage);
    return (data?.executions ?? []).map((execution) => ({
      ...execution,
      count: execution.orders,
    }));
  },
  getExecutionFile: async (executionId, stage) => {
    const { data } = await RedriveApiFactory().getRedriveOrders(
      executionId,
      stage
    );
    return { ...data, count: data?.orders };
  },
  itemHref: (itemId, stage, user) =>
    `/?stage=${encodeURIComponent(stage)}${devUserQuery(
      user
    )}&transactionId=${encodeURIComponent(itemId)}`,
};

export const PAYMENT_REDRIVE: RedriveKind = {
  name: "Payment",
  stateMachineName: "paymentredrivestatemachine",
  listExecutions: async (stage) => {
    const { data } = await PaymentRedriveApiFactory().getPaymentRedriveInfo(
      stage
    );
    return (data?.executions ?? []).map((execution) => ({
      ...execution,
      count: execution.payments,
    }));
  },
  getExecutionFile: async (executionId, stage) => {
    const { data } = await PaymentRedriveApiFactory().getPaymentRedrivePayments(
      executionId,
      stage
    );
    return { ...data, count: data?.payments };
  },
};
